module.exports = __webpack_public_path__ + "media/demo.5f6f7edc.mp4";